import type { ReactNode } from "react";
import { Select } from "shared/components";
import { PmsSyncOption } from "shared/app/RentalInfoForm/components/PmsSyncOption";
import { PMSValue } from "shared/app/RentalInfoForm/components/PmsValue";

const petOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

const getYesNo = (value: boolean) => (value ? "Yes" : "No");

interface PetPolicyPmsFieldProps {
  id: string;
  label: string;
  radioName: string;
  selectProps: {
    name: string;
    value?: boolean | null;
    onChange: (value: unknown) => void;
    error?: string;
  };
  synced: boolean;
  pmsValue?: boolean;
  pmsValueLabel?: string;
  children?: ReactNode;
  onValueChange: (value: unknown) => void;
  onSyncChange: (synced: boolean) => void;
}

export const PetPolicyPmsField = ({
  id,
  label,
  radioName,
  selectProps,
  synced,
  pmsValue,
  pmsValueLabel,
  children,
  onValueChange,
  onSyncChange
}: PetPolicyPmsFieldProps) => (
  <div className="grid grid-cols-2 gap-4 items-center">
    <div>
      <Select
        id={id}
        label={label}
        options={petOptions}
        required
        {...selectProps}
        onChange={onValueChange}
        isDisabled={synced}
      />
      {children}
      <PmsSyncOption value={synced} onChange={onSyncChange} name={radioName} />
    </div>
    <PMSValue
      value={
        pmsValueLabel ?? (pmsValue != null ? getYesNo(pmsValue) : undefined)
      }
    />
  </div>
);
